var getScrollbarWidth = require('./getScrollbarWidth.js');

module.exports = function() {

	var overlay = document.querySelector('.overlay');

	function openOverlay() {
		document.documentElement.classList.add('st-overlayed');
		document.documentElement.style.marginRight = getScrollbarWidth() + 'px';
		overlay.classList.add('st-visible');
	}

	function closeOverlay() {
		document.documentElement.classList.remove('st-overlayed');
		document.documentElement.style.marginRight = 0;
		overlay.classList.remove('st-visible');
	}

	function closePopups() {
		var popups = overlay.querySelectorAll('.popup');
		var i = 0;
		var max = popups.length;

		for(;i < max; i += 1) {
			popups[i].classList.remove('st-visible');
		}

		closeOverlay();
	}

	function setFocusToFirstInput(evt) {
		evt.target.querySelector('.form__inp').focus();
		evt.target.removeEventListener('transitionend', setFocusToFirstInput);
	}

	function showPopup(popupId) {
		var popup = overlay.querySelector('.popup--' + popupId);
		popup.classList.add('st-visible');
		popup.addEventListener('transitionend', setFocusToFirstInput);
	}

	function openPopup(popupId) {
		closePopups();
		openOverlay();
		showPopup(popupId);
	}

	overlay.addEventListener('click', function(evt) {
		if(evt.target === overlay || evt.target.classList.contains('popup__close')) {
			closePopups();
		}
	});

	document.addEventListener('click', function(evt) {
		if(evt.target.classList.contains('js-open-popup')) {
			openPopup(evt.target.dataset.popup);
		}
	});

	document.addEventListener('keyup', function(evt) {
		if(evt.keyCode === 27) {
			closePopups();
		}
	});

	if(document.querySelector('.popup.st-visible')) {
		openOverlay();
	}

};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/popups.js
 **/